import React, { useEffect, useState, FC } from "react";
import Fab from "@mui/material/Fab";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { useTheme } from "@mui/material";
import Box from "@mui/material/Box";
type Props = {
  targetElm: React.RefObject<HTMLDivElement>;
  scrollElm: React.RefObject<HTMLDivElement>;
};
const ScrollButton: FC<Props> = ({ targetElm, scrollElm }) => {
  const theme = useTheme();
  const [showScroll, setShowScroll] = useState(false);

  const checkScrollTop = () => {
    if (scrollElm.current) {
      const scrollTop = scrollElm.current.scrollTop;
      if (!showScroll && scrollTop > 100) {
        setShowScroll(true);
      } else if (showScroll && scrollTop <= 100) {
        setShowScroll(false);
      }
    }
  };

  const scrollTop = () => {
    // window.scrollTo({ top: 0, behavior: "smooth" });
    if (targetElm.current) {
      const bottom = targetElm.current.scrollIntoView({
        behavior: "smooth",
        block: "nearest",
        inline: "center",
      });
    }
  };

  useEffect(() => {
    const element = scrollElm.current;
    if (element) {
      element.addEventListener("scroll", checkScrollTop);
      return () => {
        element.removeEventListener("scroll", checkScrollTop);
      };
    }
  }, [scrollElm, showScroll]);

  return (
    <>
      {showScroll && (
        <Box
          sx={{
            position: "fixed",
            top: "calc(100vh - 50px)",
            left: "calc(1024px + calc(calc(100% - 1280px) / 3))",
            [theme.breakpoints.down("md")]: {
              top: "calc(100vh - 50px)",
              left: "calc(100% - 100px)",
            },
            [theme.breakpoints.down("sm")]: {
              top: "calc(100vh - 50px)",
              left: "calc(100% - 80px)",
            },
          }}
        >
          <Fab color={"primary"} size="small" onClick={scrollTop}>
            <KeyboardArrowUpIcon sx={{ color: theme.palette.foreColor.dark }} />
          </Fab>
        </Box>
      )}
    </>
  );
};

export default ScrollButton;
